import { Injectable, inject } from '@angular/core';
import { CmUiTableColumn } from '@cm/ui-modules';
import {
  GetCustomFieldDefinitionResponseDocument,
  GetCustomFieldDefinitionResponseQuery,
} from '@graphql';
import { Apollo } from 'apollo-angular';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ObjectName } from '@view-model';

@Injectable({
  providedIn: 'root',
})
export class CustomFieldService {
  private readonly apollo = inject(Apollo);

  private isValidColumn(column: any): column is { name: string } {
    return column != null && column.name != null;
  }

  getObjectCustomColumns(objectName: ObjectName): Observable<CmUiTableColumn[]> {
    if (objectName !== 'Contact' && objectName !== 'Lead') {
      return of([]);
    }
    return this.apollo
      .watchQuery<GetCustomFieldDefinitionResponseQuery>({
        query: GetCustomFieldDefinitionResponseDocument,
        variables: { objectName },
        fetchPolicy: 'no-cache',
      })
      .valueChanges.pipe(
        map((data) => data?.data?.getCustomFieldDefinitionResponse?.customFieldDefinitionEntryList),
        map((entryList) => entryList?.find((entry) => entry?.objectName === objectName)),
        map((entry) => entry?.customFieldDefinitionList),
        map((data) => {
          if (!data) return [];

          // Filter valid columns and remove duplicates by name
          const validColumns = data.filter(this.isValidColumn);
          const uniqueColumns = validColumns.filter(
            (column, index, arr) => arr.findIndex((c) => c.name === column.name) === index,
          );

          return uniqueColumns.map((column) => ({
            label: column.name,
            prop: `customFields.${column.name}`,
            sortable: false,
            searchable: false,
            visible: false,
            isCustomField: true,
          }));
        }),
      );
  }
}
